if (typeof wp.data != 'undefined' && typeof wp.blocks != 'undefined') {

function _unregisterBlockTypes() {
  wp.blocks.getBlockTypes().forEach(function(blockType) {
    var blocklist = window.BLOCKEDITOR_BLOCKLIST || [];

    var name = blockType.name;
    var namespace = name.substr(0, name.indexOf('/') + 1);

    if (blocklist.indexOf(namespace) > -1 || blocklist.indexOf(name) > -1) {
      wp.blocks.unregisterBlockType(name);
    }
  });
}

wp.domReady(function() {
  _unregisterBlockTypes();
});

wp.hooks.addFilter('blocks.registerBlockType', 'modifyBlockType', function(settings, name) {
  settings.supports = settings.supports || {};

  var blocklist = window.BLOCKEDITOR_BLOCKLIST || [];

  var namespace = name.substr(0, name.indexOf('/') + 1);

  var hidden = [
    // 'acf/block-gated-download',
  ];

  if (
    blocklist.indexOf(namespace) > -1 ||
    blocklist.indexOf(name) > -1 ||
    hidden.indexOf(name) > -1
  ) {
    settings = jQuery.extend(true, settings, {
      supports: {
        inserter: false
      }
    });
  }

  if (name == 'core/heading') {
    // settings.supports.align = ['wide'];
    settings.supports.align = false;
  }

  if (name == 'core/paragraph') {
    // delete settings.attributes.fontSize;
    delete settings.supports.dropCap;
  }

  if (name == 'core/group') {
    // delete settings.supports.align;
    // settings.supports.align = ['full'];
    // settings.supports.align = ['wide', 'full'];
    settings.supports.align = false;
    // settings.variations = [];
    // settings.supports.layout = false;

    if (typeof window.BLOCKEDITOR_GROUP_ALLOWED_BLOCKS !== 'undefined') {
      settings = jQuery.extend(true, settings, {
        attributes: {
          allowedBlocks: {
            default: window.BLOCKEDITOR_GROUP_ALLOWED_BLOCKS,
          }
        }
      });
    }
  }

  if (name == 'core/columns') {
    settings.supports.align = ['full'];
    // settings.supports.align = false;
  }

  if (name == 'core/column') {
    if (typeof window.BLOCKEDITOR_COLUMN_ALLOWED_BLOCKS !== 'undefined') {
      settings = jQuery.extend(true, settings, {
        attributes: {
          allowedBlocks: {
            default: window.BLOCKEDITOR_COLUMN_ALLOWED_BLOCKS,
          }
        }
      });
    }
  }

  if (name == 'core/image') {
    settings.supports.align = ['center', 'left', 'right'];
    settings.variations = [];
    // settings.usesContext = settings.usesContext.filter((context) => {
    //   return context !== 'imageCrop';
    // });
  }

  // Adds custom alignment (does not use core experimental layout controls)
  if (name == 'core/buttons') {
    // settings.supports.align = ['center','left','right'];
    settings.supports.align = false;
  }

  if (name == 'core/button') {
    settings.supports.align = false;
  }

  if (name == 'core/table') {
    // settings.supports.align = ['wide'];
    settings.supports.align = false;
  }

  return settings;
});

wp.hooks.addFilter(
  'blocks.getSaveContent.extraProps',
  'editorskit/applyExtraClass',
  function (extraProps, blockType, attributes) {
    if (blockType.name == 'core/group') {
      extraProps.className = extraProps.className + ' block_full_width';
    }

    extraProps.layout = null;

    return extraProps;
  }
);

// wp.hooks.addFilter(
//   'blocks.getBlockDefaultClassName',
//   'my-plugin/set-block-custom-class-name',
//   function (classname, name) {
//     if (name == 'core/group') {
//       classname += ' acf_align_full';
//     }
//
//     return classname;
//   }
// );

// Disable core reusable block
wp.domReady(function() {
  wp.data.dispatch('core/block-editor').updateSettings( { __experimentalReusableBlocks: [] } );
  wp.data.subscribe(function() {
    var settings = wp.data.select( 'core/block-editor' ).getSettings();
    if ( settings.__experimentalReusableBlocks && settings.__experimentalReusableBlocks.length > 0 ) {
      wp.data.dispatch('core/block-editor').updateSettings( { __experimentalReusableBlocks: [] } );
    }
  });
});

wp.domReady(function() {
  wp.blocks.registerBlockVariation(
    'core/columns', {
      name: 'custom-columns',
      title: 'Columns',
      // icon: 'columns',
      scope: ['inserter'],
      isDefault: true,
      innerBlocks: [
        ['core/column', { width: '50%' }],
        ['core/column', { width: '50%' }],
      ],
    }
  );
});

wp.domReady(function() {
  wp.blocks.unregisterBlockStyle(
    'core/image',
    [ 'default', 'rounded' ]
  );

  wp.blocks.registerBlockStyle(
    'core/image',
    [
      {
        name: 'round',
        label: 'Rounded',
        isDefault: true,
      },
      {
        name: 'default',
        label: 'Default',
        // isDefault: true,
      },

      // {
      //   name: 'circle',
      //   label: 'Circle',
      // },
      // {
      //   name: 'icon',
      //   label: 'Icon',
      // },
      // {
      //   name: 'headshot',
      //   label: 'Headshot',
      // },
    ]
  );

  // wp.blocks.registerBlockVariation(
  //   'core/image', {
  //     name: 'custom-icon',
  //     title: 'Icon',
  //     // icon: 'image',
  //     scope: ['inserter'],
  //     attributes: {
  //       className: 'icon-image'
  //     }
  //   }
  // );
});

wp.domReady(function() {
  wp.blocks.unregisterBlockStyle(
    'core/button',
    [ /* 'default', */ 'outline', 'squared', 'fill' ]
  );

  wp.blocks.registerBlockStyle(
    'core/button',
    [
      {
        name: 'solid',
        label: 'Solid',
        isDefault: true,
      },
      {
        name: 'outline',
        label: 'Outline',
      },
      // {
      //   name: 'text',
      //   label: 'Text',
      //   isDefault: true,
      // },
    ]
  );
});

wp.domReady(function() {
  wp.blocks.registerBlockStyle(
    'core/heading',
    [
      {
        name: 'default',
        label: 'Default',
        isDefault: true,
      },
      {
        name: 'headline_1',
        label: 'Headline 1',
      },
      {
        name: 'headline_2',
        label: 'Headline 2',
      },
      {
        name: 'headline_3',
        label: 'Headline 3',
      },
      {
        name: 'headline_4',
        label: 'Headline 4',
      },
      {
        name: 'headline_5',
        label: 'Headline 5',
      },
      {
        name: 'headline_6',
        label: 'Headline 6',
      },
      // {
      //   name: 'headline_7',
      //   label: 'Headline 7',
      // },
      {
        name: 'screenreader',
        label: 'Hidden',
      }
    ]
  );
});

wp.domReady(function() {
  wp.blocks.registerBlockStyle(
    'core/paragraph',
    [
      {
        name: 'default',
        label: 'Default',
        isDefault: true,
      },
      {
        name: 'large',
        label: 'Large',
      },
      {
        name: 'small',
        label: 'Small',
      },
      // {
      //   name: 'caption',
      //   label: 'Caption',
      // }
    ]
  );
});

wp.domReady(function() {
  wp.blocks.registerBlockStyle(
    'core/list',
    [
      {
        name: 'Default',
        label: 'Default',
        isDefault: true,
      },
      // {
      //   name: 'columned',
      //   label: 'Columned',
      // }
    ]
  );
});

wp.domReady(function() {
  wp.blocks.unregisterBlockVariation('core/group', 'group');
  wp.blocks.unregisterBlockVariation('core/group', 'group-row');
  wp.blocks.unregisterBlockVariation('core/group', 'group-stack');
  wp.blocks.unregisterBlockVariation('core/group', 'group-grid');

  wp.blocks.registerBlockVariation(
    'core/group', {
      name: 'custom-group',
      title: 'Group',
      // icon: 'columns',
      scope: ['inserter'],
      isDefault: true,
      innerBlocks: [
        ['core/paragraph', { }],
      ],
      attributes: {
        layout: {
          type: 'default',
          allowEditing: false,
          allowSwitching: false,
          allowInheriting: false,
          allowSizingOnChildren: false,
        },
      },
    }
  );

  wp.blocks.registerBlockStyle(
    'core/group',
    [
      // {
      //   name: 'default',
      //   label: 'Default (Transparent)',
      //   isDefault: true,
      // },
      // {
      //   name: 'teal',
      //   label: 'Teal',
      // },
      // {
      //   name: 'navy',
      //   label: 'Navy',
      // },
      // {
      //   name: 'fuchsia',
      //   label: 'Fuchsia',
      // },
      // {
      //   name: 'aqua',
      //   label: 'Aqua',
      // },
      // {
      //   name: 'salmon',
      //   label: 'Salmon',
      // },
      // {
      //   name: 'green',
      //   label: 'Green',
      // },
      // {
      //   name: 'orange',
      //   label: 'Orange',
      // }
    ]
  );

  // wp.blocks.registerBlockStyle(
  //   'acf/block-media-group',
  //   [
  //     {
  //       name: 'default',
  //       label: 'Default (Transparent)',
  //       isDefault: true,
  //     },
  //     {
  //       name: 'gray',
  //       label: 'Gray',
  //     },
  //     {
  //       name: 'red',
  //       label: 'Red',
  //     },
  //     {
  //       name: 'green',
  //       label: 'Green',
  //     }
  //   ]
  // );
});

wp.domReady(function() {
  wp.blocks.registerBlockStyle(
    'core/column',
    [
      {
        name: 'default',
        label: 'Default',
        isDefault: true,
      },
      {
        name: 'firstonmobile',
        label: 'First on Mobile',
      },
      {
        name: 'lastonmobile',
        label: 'Last on Mobile',
      }
    ]
  );
});

wp.domReady(function() {
  wp.blocks.unregisterBlockStyle(
    'core/separator',
    [ 'default', 'wide', 'dots' ]
  );
});


wp.domReady(function() {
  wp.blocks.unregisterBlockVariation('core/heading', 'stretchy-heading');
  wp.blocks.unregisterBlockVariation('core/paragraph', 'stretchy-paragraph');
});



//

// wp.domReady(function() {
jQuery(window).load(function() {
  // if (wp.data) {
    // console.log(wp.data.select('core/edit-post').isFeatureActive('welcomeGuide'));
    wp.data.select('core/edit-post').isFeatureActive('fullscreenMode') && wp.data.dispatch('core/edit-post').toggleFeature('fullscreenMode');
    wp.data.select('core/edit-post').isFeatureActive('welcomeGuide') && wp.data.dispatch('core/edit-post').toggleFeature('welcomeGuide');
  // }
});

wp.domReady(function() {
  wp.data.dispatch('core/editor').removeEditorPanel('discussion-panel');
  wp.data.dispatch('core/editor').removeEditorPanel('featured-image');
  wp.data.dispatch('core/editor').removeEditorPanel('post-excerpt');
});

}
